export class CmdDevaluationAverages {
    average: string;
    header: string;
}